import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import PageSkeleton from '../../components/PageSkeleton';
import LoadingPageError from '../../components/LoadingPageError';
const HomepageLoadable = Loadable({
  loader: () => import( /* webpackChunkName: "Homepage" */'../Homepage'),
  LoadingComponent: PageSkeleton,
  ErrorComponent: LoadingPageError
});
export default HomepageLoadable;